import { contributorTasks } from "@/features/contributor-tasks/contributor-tasks";
import type { ShellNavSection } from "./types";

export function contributionNavigation(lang: string, title: string, role?: string): ShellNavSection {
  const tasks = contributorTasks(lang).filter(({ key }) =>
    role !== "accountant" || !["transcribeInitial", "reviewInitial"].includes(key),
  );
  return {
    key: "contribution-tasks",
    title,
    items: tasks.map(({ key, label, hint, href, icon }) => ({
      key: `contribution-${key}`,
      label,
      href,
      icon,
      keywords: [hint],
    })),
  };
}
